<template>
  <p>{{ offer_codecs.join(", ") }}</p>
</template>

<script>
export default {
  props: {
    offer_codecs: Array,
  },
};
</script>

<style></style>
